module.exports = __webpack_public_path__ + "static/story3-hero-1920x1080-d87655d8d6c74dfd9b5e93be7b28b930.jpg";